var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKeyFeatures = function SvgKeyFeatures(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 23,
    fill: "none",
    viewBox: "0 0 25 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M17.818 4.016H7.182a1.56 1.56 0 0 0-1.241.672L3.28 8.369a1.534 1.534 0 0 0 .088 1.885l7.977 9.189a1.462 1.462 0 0 0 2.308 0l7.977-9.19a1.53 1.53 0 0 0 .087-1.884L19.06 4.688a1.56 1.56 0 0 0-1.241-.672"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M11.744 4 8.18 9.522l4.324 10.446"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "m13.304 4 3.55 5.522L12.5 19.968M3.04 9.521h18.932"
  })));
};
export default SvgKeyFeatures;